"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Tile = exports.getClassNames = void 0;

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

var getClassNames = (0, _react.memoizeFunction)(function () {
  return {
    root: (0, _react.mergeStyles)({
      width: '260px',
      boxSizing: 'border-box',
      float: 'left',
      display: 'flex',
      flexDirection: 'column',
      border: '1px solid #ccc',
      margin: '5px',
      alignItems: 'center',
      padding: '20px',
      cursor: 'pointer'
    })
  };
});
exports.getClassNames = getClassNames;

var Tile = function Tile(props) {
  var children = props.children;
  var classNames = getClassNames();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-is-focusable": true,
    className: (0, _react.css)('ms-Tile', classNames.root, props.className),
    onClick: props.onClick,
    children: children
  });
};

exports.Tile = Tile;